'use client';

import { useEffect } from 'react';
import "./floatingbutton.css";

export default function ScrollProgress() {
  useEffect(() => {
    const progressWrap = document.querySelector('.progress-wrap') as HTMLElement;
    const progressPath = document.querySelector('.progress-wrap path') as SVGPathElement;

    if (!progressWrap || !progressPath) return;

    const pathLength = progressPath.getTotalLength();
    const offset = 50;

    progressPath.style.transition = 'none';
    progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
    progressPath.style.strokeDashoffset = `${pathLength}`;
    progressPath.getBoundingClientRect();
    progressPath.style.transition = 'stroke-dashoffset 10ms linear';

    const updateProgress = () => {
      const scroll = window.scrollY;
      const height = document.documentElement.scrollHeight - window.innerHeight;
      const progress = pathLength - (scroll * pathLength / height);
      progressPath.style.strokeDashoffset = `${progress}`;

      if (scroll >= offset) {
        progressWrap.classList.add('active-progress');
      } else {
        progressWrap.classList.remove('active-progress');
      }
    };

    const handleClick = (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleTouchStart = (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
    };

    const handleTouchEnd = (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    window.addEventListener('scroll', updateProgress);
    progressWrap.addEventListener('click', handleClick);
    progressWrap.addEventListener('touchstart', handleTouchStart);
    progressWrap.addEventListener('touchend', handleTouchEnd);

    updateProgress(); 

    return () => {
      window.removeEventListener('scroll', updateProgress);
      if (progressWrap) {
        progressWrap.removeEventListener('click', handleClick);
        progressWrap.removeEventListener('touchstart', handleTouchStart);
        progressWrap.removeEventListener('touchend', handleTouchEnd);
      }
    };
  }, []);

  return (
    <div
      className="progress-wrap"
      style={{ touchAction: 'manipulation' }}
      role="button"
      tabIndex={0}
      aria-label="Scroll to top"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }}
    >
      <svg className="progress-circle" width="100%" height="100%" viewBox="-1 -1 102 102" aria-hidden="true">
        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
      </svg>
      <div className="progress-arrow" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#DA159B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="19" x2="12" y2="5" />
          <polyline points="5 12 12 5 19 12" />
        </svg>
      </div>
    </div>
  );
}
